import { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { GetExternalServiceStatusFn } from '../../pages/StackedCoverPage/hooks/useContentStackEventHandlers';
import { StackedCoverPage } from '../../pages/StackedCoverPage/StackedCoverPage';
import { SuperCoverPageContext } from '../../pages/StackedCoverPage/SuperCoverPageContext';
import { AssetNotFound } from '../errorPage/AssetNotFound';
import { PlayerFutureAssetDialog } from '../playerDialog';

import { CoverPagePath, CoverPagePaths, PlayerDialogues } from './coverpage.types';
import { CoverPageChannel } from './CoverPageChannel';
import { RedirectOldCoverPageVod } from './RedirectOldCoverPageVod';
import { RedirectOldTvSeriesCoverPage } from './RedirectOldTvSeriesCoverPage';

export type CoverPageRouterProps = Omit<PlayerDialogues, 'futureAssetDialogue'> & {
  getExternalServiceStatus: GetExternalServiceStatusFn;
};

export const CoverPageRouter: FC<CoverPageRouterProps> = ({ getExternalServiceStatus, ...dialogs }) => {
  const { type, id } = useParams<{ id: string; type: CoverPagePath }>();
  const { pathname } = useLocation();

  //CoverPageChannel handles missing channelId internally by redirecting to last played or default channel
  if (pathname.includes(`/${CoverPagePaths.LIVE}/`)) {
    const { ...liveProps } = { futureAssetDialogue: PlayerFutureAssetDialog, ...dialogs };
    return <CoverPageChannel channelId={id} {...liveProps} />;
  }

  if (!id) {
    return <AssetNotFound contextInfo="CoverPageRouter, missing id for non-live coverpage" />;
  }

  if (
    pathname.includes(`/${CoverPagePaths.STACKED_SERIES}/`) ||
    pathname.includes(`/${CoverPagePaths.STACKED_MOVIE}/`)
  ) {
    return (
      <SuperCoverPageContext.Provider value={{ getExternalServiceStatus }}>
        <StackedCoverPage id={id} />
      </SuperCoverPageContext.Provider>
    );
  }

  switch (type?.toLowerCase()) {
    case CoverPagePaths.VOD:
      return <RedirectOldCoverPageVod assetId={id} />;
    case CoverPagePaths.SERIES:
      return <RedirectOldTvSeriesCoverPage seriesId={id} />;
    default:
      return <AssetNotFound contextInfo="default return after all redirects" />;
  }
};
